import { render, staticRenderFns } from "./BosLoader.vue?vue&type=template&id=7011f11e"
import script from "./BosLoader.vue?vue&type=script&lang=js"
export * from "./BosLoader.vue?vue&type=script&lang=js"
import style0 from "./BosLoader.vue?vue&type=style&index=0&id=7011f11e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports